import axios from 'axios';
import { AdresseIP } from './AdresseIp';

/*
 * Paramétrage du paiement du loyer, par cité.
 *
 * Objet manipulé :
 * {
 *   idParametrePaiement     : number,  // 0 à la création
 *   idCite                  : number,
 *   nomCite                 : string,  // renvoyé par le back, non envoyé
 *   nbMoisOccupation        : number,  // durée totale d'occupation, en mois
 *   nbMoisCaution           : number,  // caution, exprimée en mois de loyer
 *   nbMoisPremierVersement  : number,  // mois de loyer payés au 1er versement
 *   nbEcheanceReste         : number   // en combien de tranches le reste est dû
 * }
 *
 * Le nombre de mois restants n'est pas stocké : il vaut
 * nbMoisOccupation - nbMoisPremierVersement.
 */
export class ParametrePaiementService {

    constructor(){
        this.adresse = new AdresseIP()
    }

    getAll() {

        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/parametre-paiement')
                    .then(res => res.data);
    }
    create(newParametrePaiement) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/parametre-paiement'
        return axios.post(url,newParametrePaiement)
                    .then(res => res.data);
    }
    update(idParametrePaiement ,newParametrePaiement) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/parametre-paiement/'
        return axios.put(url+idParametrePaiement, newParametrePaiement)
                    .then(res => res.data);
    }
    delete(idParametrePaiement) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/parametre-paiement/'
        return axios.patch(url+idParametrePaiement)
                    .then(res => res.data)
    }
    getParametreCite(idCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/parametre-paiement-cite/'
        return axios.get(url+idCite)
                    .then(res => res.data)
    }

}
